<header>
  <dx-toolbar class="header-toolbar">
    <dxi-item
      *ngIf="menuToggleEnabled"
      location="before"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }">
    </dxi-item>
    <dxi-item location="before" cssClass="breadcrumb-item">
      <ng-template dxTemplate="itemTemplate">
        <div class="breadcrumbs-container">
          <ul class="breadcrumbs">
            <li *ngFor="let breadcrumb of (breadcrumbs$ | async); let i = index;">
              <a [href]="breadcrumb.url"><span *ngIf="i > 0" class="ml-2 mr-2">></span>{{ breadcrumb.label }}</a>
            </li>
          </ul>
        </div>
      </ng-template>
    </dxi-item>
    <dxi-item
      location="center"
      cssClass="menu-button">
      <img (click)="navigateToHome()" src="../../../../assets/img/logo.png" class="logo" style="cursor: pointer;">
    </dxi-item>

    <dxi-item
      location="after"
      locateInMenu="auto"
      menuItemTemplate="menuItem">
      <div *dxTemplate="let data of 'item'">
        <dx-button
          class="user-button authorization"
          width="210px"
          height="100%"
          stylingMode="text">
          <div *dxTemplate="let data of 'content'">
            <app-user-panel [menuMode]="'context'"></app-user-panel>
          </div>
        </dx-button>
      </div>
    </dxi-item>
    <div *dxTemplate="let data of 'menuItem'">
      <app-user-panel [menuMode]="'list'"></app-user-panel>
    </div>
  </dx-toolbar>
</header>
